import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrganisationService } from '@services/organisations/organisation.service';
import { DataTableEvent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'organisation-selection',
    templateUrl: './organisation-selection.component.html',
    styleUrls: ['./organisation-selection.component.scss'],
    providers: [OrganisationService],
    standalone: false
})
export class OrganisationSelectionComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OrganisationSelectionComponent>,
    public organisationService: OrganisationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
  }

  onSelect(event: DataTableEvent) {
    this.dialogRef.close(event.row);
  }

  abort() {
    this.dialogRef.close();
  }

}
